import React from "react";
import { Plus, X } from "lucide-react";
import {
  LeadTimeUnit,
  LEAD_TIME_UNITS,
  ReminderInputDto,
} from "../../../services/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { LEAD_TIME_UNIT_LABELS, leadTimeUnitToInt } from "../utils";

interface ReminderRow {
  id?: string;
  leadTimeValue: number;
  leadTimeUnit: LeadTimeUnit;
}

interface Props {
  reminders: ReminderRow[];
  onChange: (rows: ReminderRow[]) => void;
}

export const ReminderEditor: React.FC<Props> = ({ reminders, onChange }) => {
  const update = (index: number, patch: Partial<ReminderRow>) => {
    const next = reminders.slice();
    next[index] = { ...next[index], ...patch };
    onChange(next);
  };
  const remove = (index: number) => {
    const next = reminders.slice();
    next.splice(index, 1);
    onChange(next);
  };
  const add = () => {
    onChange([...reminders, { leadTimeValue: 1, leadTimeUnit: "Days" }]);
  };

  return (
    <div className="space-y-2">
      <Label>Avisos por Discord (antelación)</Label>
      {reminders.length === 0 && (
        <p className="text-xs text-slate-500">
          Sin avisos. Añade uno o varios (ej. 1 semana, 1 día, 2 horas antes).
        </p>
      )}
      <div className="space-y-2">
        {reminders.map((r, i) => (
          <div key={i} className="flex items-center gap-2">
            <Input
              type="number"
              min={1}
              className="w-24"
              value={r.leadTimeValue}
              onChange={(e) => update(i, { leadTimeValue: parseInt(e.target.value || "0", 10) })}
            />
            <Select
              value={r.leadTimeUnit}
              onValueChange={(v) => update(i, { leadTimeUnit: v as LeadTimeUnit })}
            >
              <SelectTrigger className="w-32"><SelectValue /></SelectTrigger>
              <SelectContent>
                {LEAD_TIME_UNITS.map((u) => (
                  <SelectItem key={u} value={u}>{LEAD_TIME_UNIT_LABELS[u]}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            <span className="text-sm text-slate-500">antes</span>
            <Button type="button" size="sm" variant="ghost" onClick={() => remove(i)}>
              <X className="size-3.5" />
            </Button>
          </div>
        ))}
      </div>
      <Button type="button" size="sm" variant="outline" onClick={add}>
        <Plus className="size-3.5 mr-1.5" /> Añadir aviso
      </Button>
    </div>
  );
};

export function remindersToApi(rows: ReminderRow[]): ReminderInputDto[] {
  return rows.map((r) => ({
    id: r.id,
    leadTimeValue: r.leadTimeValue,
    leadTimeUnit: leadTimeUnitToInt(r.leadTimeUnit),
  }));
}
